<template>
	<div class="page">
		<a-row style="margin-bottom: 8px">
			<a-form layout="inline" :form="form" @submit="handleSearch">
				<a-form-item :label="`关键字`">
					<a-input :span="10" v-decorator="[`kw`]" placeholder="公司名称/负责人" />
				</a-form-item>
				<a-form-item>
					<a-button type="primary" html-type="submit">搜索</a-button>
					<a-button :style="{ marginLeft: '8px' }" @click="clearSearchForm">清空</a-button>
				</a-form-item>
				<a-form-item style="margin-left: 16px">
					<a-button type="primary" @click="addNew">添加物业</a-button>
				</a-form-item>
			</a-form>
		</a-row>
		<a-table
			:columns="table.header"
			:data-source="data"
			:locale="table.locale"
			:loading="table.loading"
			rowKey="id"
			:scroll="{ y: table.scrollHeight }"
			:pagination="pagination"
			@change="tableChange"
		>
			<div slot="name" slot-scope="item">
				<p>
					<b>简称：</b>
					{{ item.shortName }}
				</p>
				<p>
					<b>全称：</b>
					{{ item.fullName }}
				</p>
			</div>
			<span slot="mode" slot-scope="item">{{ item.upholdMode === 1 ? '按项目维护' : '按物业公司维护' }}</span>
			<div slot="period" slot-scope="item">
				<p>起始：{{ item.periodStart ? $moment(item.periodStart).format('YYYY-MM-DD') : '-' }}</p>
				<p>结束：{{ item.periodEnd ? $moment(item.periodEnd).format('YYYY-MM-DD') : '-' }}</p>
			</div>
			<div slot="manager" slot-scope="item">
				<p>姓名：{{ item.managerName ? item.managerName : '-' }}</p>
				<p>电话：{{ item.managerTel ? item.managerTel : '-' }}</p>
				<p>手机号：{{ item.managerMobile ? item.managerMobile : '-' }}</p>
			</div>
			<div slot="enable" slot-scope="item">
				<a-switch v-model="item.enable" checked-children="已启用" un-checked-children="未启用" @change="switchEnable(item)" />
			</div>
			<div slot="ops" slot-scope="item" >
				<a-button class="ops-button" type="primary" @click="editRow(item)">编辑</a-button>
				<a-button class="ops-button" type="primary" @click="grantMod(item,1)">PC功能分配</a-button>
        <a-button class="ops-button" type="primary" @click="grantMod(item,2)">APP功能分配</a-button>
			</div>
		</a-table>
		<!--添加物业-->
		<a-modal
			title="添加物业公司"
			width="60vw"
			:mask-closable="false"
			:ok-text="`确定`"
			:cancel-text="`取消`"
			:visible="modal.addNew.show"
			:confirm-loading="modal.addNew.confirmLoading"
			:dialog-style="{ minWidth: '700px', maxWidth: '900px', top: '30%', marginTop: '-100px' }"
			@ok="addNewConfirm"
			@cancel="addNewCancel"
		>
			<a-form :form="modal.addNew.form" :label-col="{ span: '6' }" :wrapper-col="{ span: 14 }">
				<a-row>
					<a-col :span="10">
						<a-form-item :label="`简称`">
							<a-input v-decorator="[`shortName`, { rules: [{ required: true, message: '请输入物业公司简称' }] }]" placeholder="物业公司简称" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`全称`">
							<a-input v-decorator="[`fullName`, { rules: [{ required: true, message: '请输入物业公司全称' }] }]" placeholder="物业公司全称" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`维护模式`">
							<a-select :default-value="1" v-model="modal.addNew.model.upholdMode" placeholder="选择维护模式">
								<a-select-option :value="1">按项目维护</a-select-option>
								<a-select-option :value="2">按物业公司维护</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`费用（金额）`">
							<a-input v-decorator="[`upholdAmt`, { rules: [{ required: true, message: '请输入维护费用' }] }]" placeholder="维护费用" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`使用期限`">
							<a-range-picker v-decorator="[`periodRange`]" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`项目数量限制`" :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
							<a-input-number
								style="width: 120px"
								:min="1"
								:max="99"
								width="150"
								v-decorator="[`projectLimit`, { rules: [{ required: true, message: '数量' }] }]"
								placeholder="项目限制数量"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`负责人姓名`" :wrapper-col="{ span: 8 }">
							<a-input v-decorator="[`managerName`, { rules: [{ required: true, message: '请输入负责人姓名' }] }]" placeholder="负责人姓名" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`负责人电话`">
							<a-input v-decorator="[`managerTel`, { rules: [{ required: true, message: '请输入负责人电话' }] }]" placeholder="负责人电话" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`负责人手机`">
							<a-input
								v-decorator="[`managerMobile`, { rules: [{ required: true, message: '请输入负责人手机号' }] }]"
								placeholder="负责人手机号"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`负责人密码`">
							<a-input v-decorator="[`managerPassword`, { rules: [{ required: true, message: '请输入密码' }] }]" placeholder="负责人初始化密码" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`公司电话`">
							<a-input v-decorator="[`companyTel`, { rules: [{ required: true, message: '请输入公司电话' }] }]" placeholder="公司电话" />
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<hr style="background-color: #dfdfdf; border: none; height: 1px" />
						<a-form-item :label="`是否启用`" :label-col="{ span: 3 }">
							<a-switch v-model="modal.addNew.model.enable" checked-children="启用" un-checked-children="不启用" />
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<a-form-item :label="`独享库名`" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
							<a-input v-decorator="['schemaName']" placeholder="独享数据库名" />
						</a-form-item>
					</a-col>
				</a-row>
			</a-form>
		</a-modal>

		<!--编辑物业-->
		<a-modal
			title="编辑物业公司"
			width="60vw"
			:mask-closable="false"
			:ok-text="`确定`"
			:cancel-text="`取消`"
			:visible="modal.edit.show"
			:confirm-loading="modal.edit.confirmLoading"
			:dialog-style="{ minWidth: '700px', maxWidth: '900px', top: '30%', marginTop: '-100px' }"
			@ok="editConfirm"
			@cancel="editCancel"
		>
			<a-form :form="modal.edit.form" :label-col="{ span: '6' }" :wrapper-col="{ span: 14 }">
				<a-row>
					<a-col :span="10">
						<a-form-item :label="`简称`">
							<a-input v-decorator="[`shortName`, { rules: [{ required: true, message: '请输入物业公司简称' }] }]" placeholder="物业公司简称" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`全称`">
							<a-input v-decorator="[`fullName`, { rules: [{ required: true, message: '请输入物业公司全称' }] }]" placeholder="物业公司全称" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`维护模式`">
							<a-select v-model="modal.edit.model.upholdMode" placeholder="选择维护模式">
								<a-select-option :value="1">按项目维护</a-select-option>
								<a-select-option :value="2">按物业公司维护</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`费用（金额）`">
							<a-input v-decorator="[`upholdAmt`, { rules: [{ required: true, message: '请输入维护费用' }] }]" placeholder="维护费用" />
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`使用期限`">
							<a-range-picker v-decorator="[`periodRange`]" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`项目数量限制`" :label-col="{ span: 6 }" :wrapper-col="{ span: 10 }">
							<a-input-number
								style="width: 120px"
								:min="1"
								:max="99"
								width="150"
								v-decorator="[`projectLimit`, { rules: [{ required: true, message: '数量' }] }]"
								placeholder="项目限制数量"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`负责人姓名`" :wrapper-col="{ span: 8 }">
							<a-input v-decorator="[`managerName`, { rules: [{ required: true, message: '请输入负责人姓名' }] }]" placeholder="负责人姓名" />
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`负责人电话`">
							<a-input
								v-decorator="[`managerTel`, { rules: [{ required: true, message: '请输入负责人办公电话' }] }]"
								placeholder="负责人办公电话"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="10">
						<a-form-item :label="`负责人手机`">
							<a-input
								v-decorator="[`managerMobile`, { rules: [{ required: true, message: '请输入负责人手机号' }] }]"
								placeholder="负责人手机号"
							/>
						</a-form-item>
					</a-col>
					<a-col :span="12">
						<a-form-item :label="`公司电话`">
							<a-input v-decorator="[`companyTel`, { rules: [{ required: true, message: '请输入公司电话' }] }]" placeholder="公司电话" />
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<hr style="background-color: #dfdfdf; border: none; height: 1px" />
						<a-form-item :label="`是否启用`" :label-col="{ span: 3 }">
							<a-switch v-model="modal.edit.model.enable" checked-children="启用" un-checked-children="不启用" />
						</a-form-item>
					</a-col>
					<a-col :span="24">
						<a-form-item :label="`独享库名`" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }">
							<a-input v-decorator="['schemaName']" placeholder="独享数据库名" />
						</a-form-item>
					</a-col>
				</a-row>
			</a-form>
		</a-modal>

		<!--功能分配-->
		<a-modal
			title="功能分配"
			width="40vw"
			:mask-closable="false"
			:show-line="true"
			:ok-text="`确定`"
			:cancel-text="`取消`"
			:visible="modal.modGrant.show"
			:confirm-loading="modal.modGrant.confirmLoading"
			:dialog-style="{ minWidth: '300px', maxWidth: '500px', top: '30%', marginTop: '-100px' }"
			@ok="grantModConfirm"
			@cancel="grantModCancel"
		>
			<a-tree
				checkable
				:tree-data="modal.modGrant.tree.data"
				default-expand-all
				:checkedKeys="modal.modGrant.tree.checkedKeys"
				@check="grantModTreeChecked"
			></a-tree>
		</a-modal>
	</div>
</template>

<script>
import EstateCompanyService from '@/service/EstateCompanyService';
import FuncModService from '@/service/FuncModService';

export default {
	name: 'EstateCompanyIndex',
	data() {
		return {
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
			},
			kw: null,
			table: {
				loading: true,
				header: [
					{
						title: '名称',
						width: 200,
						scopedSlots: { customRender: 'name' },
					},
					{
						title: '维护模式',
						width: 150,
						scopedSlots: { customRender: 'mode' },
					},
					{
						title: '维护费用（金额）',
						dataIndex: 'upholdAmt',
						width: 150,
					},
					{
						title: '项目数量限制',
						dataIndex: 'projectLimit',
					},
					{
						title: '有效期',
						scopedSlots: { customRender: 'period' },
					},
					{
						title: '负责人',
						scopedSlots: { customRender: 'manager' },
					},
					{
						title: '启用',
						scopedSlots: { customRender: 'enable' },
					},
					{
						title: '操作',
            width: 350,
						scopedSlots: { customRender: 'ops' },
					},
				],
				locale: {
					emptyText: '暂无数据',
				},
				scrollHeight: 0,
			},
			form: this.$form.createForm(this, { name: 'searchForm' }),
			expand: false,
			data: [],
			modal: {
				//创建模态框
				addNew: {
					show: false,
					confirmLoading: false,
					form: this.$form.createForm(this, { name: 'formCreateNew' }),
					model: {
						upholdMode: 1,
						enable: false,
					},
				},
				//编辑模态框
				edit: {
					id: null,
					show: false,
					confirmLoading: false,
					form: this.$form.createForm(this, { name: 'formEdit' }),
					model: {
						upholdMode: 1,
						enable: false,
					},
				},
				//模块分配模态框
				modGrant: {
					ecId: null,
					show: false,
					confirmLoading: false,
					tree: {
						data: null,
						checkedKeys: [],
						checkedNodes: [],
					},
					model: {},
				},
        menuType:1
			},

		};
	},
	methods: {
		clearSearchForm() {
			this.form.resetFields();
		},
		handleSearch(e) {
			e.preventDefault();
			let _this = this;
			this.form.validateFields((err, values) => {
				if (!err) {
					_this.pagination.current = 1;
					_this.pagination.total = 0;
					_this.kw = values.kw;
					_this.reloadData();
				}
			});
		},
		editRow(item) {
			this.modal.edit.show = true;
			if (item.periodStart && item.periodEnd) {
				item.periodRange = [this.$moment(item.periodStart, 'YYYY-MM-DD'), this.$moment(item.periodEnd, 'YYYY-MM-DD')];
			}
			this.modal.edit.id = item.id;
			this.modal.edit.model.enable = item.enable;
			this.modal.edit.model.upholdMode = item.upholdMode;
			this.$nextTick(() => {
				this.modal.edit.form.setFieldsValue(item);
			});
		},
		switchEnable(item) {
			console.log('it', item);
			let _this = this;
			this.$confirm({
				title: '确定' + (item.enable ? '启用' : '启用') + '该物业公司吗？',
				content: '点击确定生效',
				onOk() {
					EstateCompanyService.switchEnable(item.id, item.enable)
						.then(da => {
							console.log('切换成功');
						})
						.catch(e => {
							console.log('e', e);
							_this.$message.error(e);
							item.enable = !item.enable;
						});
				},
			});
		},
		addNew() {
			this.modal.addNew.show = true;
		},
		addNewCancel() {
			this.modal.addNew.form.resetFields();
			this.modal.addNew.show = false;
		},
		editCancel() {
			this.modal.edit.form.resetFields();
			this.modal.edit.show = false;
		},
		editConfirm(e) {
			e.preventDefault();
			let _this = this;
			this.modal.edit.form.validateFields((err, values) => {
				if (!err) {
					values.enable = _this.modal.edit.model.enable;
					values.periodStart = null;
					values.periodEnd = null;
					if (values.periodRange && values.periodRange.length === 2) {
						values.periodStart = values.periodRange[0].format('YYYY-MM-DD');
						values.periodEnd = values.periodRange[1].format('YYYY-MM-DD');
					}
					values.upholdMode = _this.modal.edit.model.upholdMode;
					console.log('验证通过', values);
					if (_this.modal.edit.model.enable) {
						if (!values.schemaName || values.schemaName.length > 30 || values.schemaName.length < 4) {
							_this.modal.edit.form.setFields({
								schemaName: {
									value: values.schemaName,
									errors: [new Error('数据库库名校验失败')],
								},
							});
							return;
						}
					}
					_this.$confirm({
						title: '确定提交以上信息吗？',
						content: '请仔细核对信息后再提交',
						onOk() {
							_this.modal.edit.confirmLoading = true;
							EstateCompanyService.updateCompany(_this.modal.edit.id, values)
								.then(data => {
									_this.modal.edit.confirmLoading = false;
									_this.modal.edit.show = false;
									_this.reloadData();
								})
								.catch(e => {
									_this.$message.error(e);
									_this.modal.edit.confirmLoading = false;
								});
						},
					});
				}
			});
		},
		addNewConfirm(e) {
			e.preventDefault();
			let _this = this;
			this.modal.addNew.form.validateFields((err, values) => {
				if (!err) {
					values.enable = this.modal.addNew.model.enable;
					values.periodStart = null;
					values.periodEnd = null;
					if (values.periodRange && values.periodRange.length === 2) {
						values.periodStart = values.periodRange[0].format('YYYY-MM-DD');
						values.periodEnd = values.periodRange[1].format('YYYY-MM-DD');
					}
					values.upholdMode = this.modal.addNew.model.upholdMode;
					console.log('验证通过', values);
					if (this.modal.addNew.model.enable) {
						if (!values.schemaName || values.schemaName.length > 30 || values.schemaName.length < 4) {
							this.modal.addNew.form.setFields({
								schemaName: {
									value: values.schemaName,
									errors: [new Error('数据库库名校验失败')],
								},
							});
							return;
						}
					}
					this.$confirm({
						title: '确定提交以上信息吗？',
						content: '请仔细核对信息后再提交',
						onOk() {
							_this.modal.addNew.confirmLoading = true;
							EstateCompanyService.addCompany(values)
								.then(data => {
									_this.modal.addNew.confirmLoading = false;
									_this.modal.addNew.show = false;
									_this.reloadData();
								})
								.catch(e => {
									_this.$message.error(e);
									_this.modal.addNew.confirmLoading = false;
								});
						},
					});
				}
			});
		},
		reloadData() {
			this.table.loading = true;
			let _this = this;
			EstateCompanyService.getList(this.pagination.current, this.pagination.pageSize, this.kw)
				.then(data => {
					_this.pagination.total = data.total;
					_this.pagination.current = data.pageNum;
					_this.table.loading = false;
					_this.data = data.list;
				})
				.catch(e => {
					_this.table.loading = false;
					_this.$message.error('数据获取失败');
				});
		},
		//表格改变
		tableChange(pagination) {
			this.pagination.current = pagination.current;
			this.reloadData();
		},
		//功能分配
		grantMod(item,menuType) {
      this.menuType=menuType
			this.modal.modGrant.show = true;
			this.modal.modGrant.ecId = item.id;
			let _this = this;
			_this.modal.modGrant.tree.checkedKeys.splice(0, _this.modal.modGrant.tree.checkedKeys.length);
			_this.modal.modGrant.tree.checkedNodes.splice(0, _this.modal.modGrant.tree.checkedNodes);
			//获取功能模块
			FuncModService.treeData(true,menuType)
				.then(data => {
					_this.modal.modGrant.tree.data = data;
				})
				.catch(e => {
					console.log('获取数据失败...', e);
					this.$message.error(e + ',模块数据获取失败');
				});

			//获取已分配模块
			FuncModService.ecModGrantList(item.id,menuType)
				.then(da => {
					if (da != null && da.length > 0) {
						for (const di of da) {
							_this.modal.modGrant.tree.checkedKeys.push(di.key);
						}
					}
				})
				.catch(e => {
					console.log('e', e);
					this.$message.error(e + ',已分配模块获取失败');
				});
		},
		grantModConfirm() {
			let _this = this;
			let modIds = [];
			for (let node of this.modal.modGrant.tree.checkedNodes) {
				modIds.push(node.id);
			}
			this.$confirm({
				title: '确认更新分配模块到该物业公司吗？',
				content: '点击确认提交数据',
				onOk() {
					_this.modal.modGrant.confirmLoading = true;
					FuncModService.ecModGrantUpdate(_this.modal.modGrant.ecId, modIds,_this.menuType)
						.then(da => {
							_this.modal.modGrant.show = false;
							_this.modal.modGrant.confirmLoading = false;
						})
						.catch(e => {
							_this.$message.error(e);
							_this.modal.modGrant.confirmLoading = false;
						});
				},
			});
		},
		grantModCancel() {
			this.modal.modGrant.show = false;
		},
		//复选框
		grantModTreeChecked(checkedKeys, all) {
			console.log('check', checkedKeys, all);
			this.modal.modGrant.tree.checkedKeys.splice(0, this.modal.modGrant.tree.checkedKeys.length);
			this.modal.modGrant.tree.checkedNodes.splice(0, this.modal.modGrant.tree.checkedNodes.length);
			for (let node of all.checkedNodes) {
				this.modal.modGrant.tree.checkedKeys.push(node.data.props.dataRef.key);
				this.modal.modGrant.tree.checkedNodes.push(node.data.props.dataRef);
			}
		},
	},
	mounted() {
		this.reloadData();
		this.table.scrollHeight = (document.documentElement.clientHeight || document.body.clientHeight) - 290;
		console.log('sc', this.table.scrollHeight);
	},
};
</script>

<style scoped>
.page {
	padding: 8px 0;
}
</style>